import { Card } from '@ui/themed';
import { t } from 'i18next';
import { SettingActionRow } from '../../../components/setting-action-row';
import { DOCS_URLS, I18N_PAGE } from '../constants';
import type { ConfigurationsModal } from '../types';
import { SettingRow } from './setting-row';

const FIELDS = `${I18N_PAGE}.cards.store_settings.fields` as const;
const TITLE = `${I18N_PAGE}.cards.store_settings.title` as const;
const COMPONENTS = 'features:configurations.components';

export function StoreSettingsCard({
  openVueModal,
}: {
  openVueModal: (modal: ConfigurationsModal) => void;
}) {
  return (
    <Card>
      <Card.Header headingLevel="h2">{t(TITLE)}</Card.Header>
      <Card.Body>
        <div className="divide-y divide-gray-200">
          <SettingRow>
            <SettingActionRow
              label={t(`${FIELDS}.store_details.label`)}
              description={t(`${FIELDS}.store_details.description`)}
              learnMoreUrl={DOCS_URLS.dashboardConfigurations}
              actionLabel={t(`${COMPONENTS}.setting_action_row.edit`)}
              onAction={() => openVueModal('store-details')}
            />
          </SettingRow>
        </div>
      </Card.Body>
    </Card>
  );
}
